import React, { useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import Button from '@stone/ui/button/Button';
const RegistrationSuccessful = (props) => {
    const { t } = useTranslation();
    const domComponent = useRef();
    useLayoutEffect(() => {
        let header = document.querySelector('.login-modal .modal__header');
        if (header && props.inDialogLogin) {
            header.style.display = 'none';
        }
        return () => {
            if (header && props.inDialogLogin) {
                header.style.display = 'block';
            }
        };
    }, []);
    return (React.createElement("div", { ref: domComponent, className: classNames('login-registration__registration-successful', props.classNames) },
        React.createElement("h2", { className: "font__title" }, t('modal.loginregister.successfull')),
        React.createElement("div", { className: "mb-32" },
            React.createElement("p", null, t('modal.loginregister.thankyou1')),
            React.createElement("p", null, t('modal.loginregister.thankyou2'))),
        React.createElement(Button, { type: "button", cls: ['button--primary'], className: "full", onClick: () => {
                if (props.reloadPage && !props.reloadComponent) {
                    window.location.reload();
                }
                else if (props.reloadComponent) {
                    props.updateLoggeedStatus(true);
                    window.loggedin = true;
                    customEventBus.emit('account:update', {});
                }
                else {
                    props.closeModal();
                }
            } }, t('modal.loginregister.keepbrowsing'))));
};
export default RegistrationSuccessful;
